<template>
	<div class="text-right">
		<div class="main flex items-center justify-center">
			<LoadingSpinner v-if="loading" />
			<div v-else>
				<img
					:src="damageCase.thumbnail.base64Content"
					v-if="damageCase.thumbnail && damageCase.thumbnail.base64Content"
					class="mb-4 md:h-96 m-auto"
					:alt="$t('overview_image')"
				/>
				<BaseCamera
					orientation="landscape"
					@snapshot="
						damageCase.thumbnail.base64Content = $event;
						$store.commit('setConfirmLeaving', $t('leave_page'));
					"
					:disable-success-message="true"
					:enable-preview="false"
					:label="btnLabel"
				/>
			</div>
		</div>
		<div class="flex justify-end">
			<BaseButton @click="save" class="mb-4 mr-8 btn-blue" :disabled="isUploading">
				<font-awesome-icon :icon="['fas', 'spinner']" class="mr-2" spin v-if="isUploading" />
				{{ $t('general.save') }}
			</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import { DamagecasesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import BaseCamera from '@/components/forms/inputs/BaseCamera';
import ProcessLog from '@/mixins/damagecase/ProcessLog';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
export default {
	name: 'Tumbnail',
	components: { LoadingSpinner, BaseCamera, BaseButton },
	mixins: [ProcessLog],
	data() {
		return {
			loading: true,
			damageCase: {
				thumbnail: {
					base64Content: null,
				},
			},
			api: DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios),
			isUploading: false,
		};
	},
	computed: {
		btnLabel() {
			if (this.damageCase.thumbnail.base64Content) return this.$t('change_overview_image');
			return this.$t('store_overview_image');
		},
	},
	methods: {
		getTumbnail() {
			this.api
				.damagecasesIdImageTypeGet(parseInt(this.$route.params.processId || this.$route.params.id), 'thumbnail')
				.then(response => {
					this.damageCase.thumbnail = response.data;
				})
				.catch(error => {})
				.finally(() => (this.loading = false));
		},
		getDamageCaseFromApi: function() {
			this.api
				.damagecasesIdGet(parseInt(this.$route.params.processId || this.$route.params.id))
				.then(response => {
					this.damageCase = { ...response.data };
					this.getTumbnail();
				})
				.catch(error => {});
		},
		save: function() {
			this.isUploading = true;
			this.api
				.damagecasesIdImageTypePost(parseInt(this.$route.params.processId || this.$route.params.id), 'thumbnail', this.damageCase.thumbnail)
				.then(response => {
					this.$store.commit('clearDamageCaseThumbnail');
					this.reportProcessChange(this.$route.params.processId || this.$route.params.id);
					this.isUploading = false;
					this.$swal({
						title: this.$t('general.success').toString(),
						text: this.$t('photo_saved').toString(),
						icon: 'success',
					}).then(() => {
						this.$store.commit('setConfirmLeaving', false);
						this.$router.push({
							name: 'management.process.edit',
							params: { processId: this.$store.getters.getDamageCase.id, customer: this.$store.getters.getDamageCase.customer.id },
						});
					});
				})
				.catch(error => {
					this.isUploading = false;
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				});
		},
	},
	mounted() {
		if (!this.damageCase) {
			this.getDamageCaseFromApi();
		} else {
			this.getTumbnail();
		}
	},
};
</script>

<style scoped>
.main {
	min-height: 60vh;
}
</style>
